/* ============================================================
   ÉKO '77 — CONTACT, THE ENQUIRY FORM

   What the reference's inline script does on
   eko77-redesign.pages.dev/contact/#enquiries, minus the mailto: mock:

     · the form is novalidate, so the browser's own bubble never appears and
       every message is painted in the field's own .fld__err line;
     · a required field that is empty gets .is-bad on its .fld, and the first
       one takes focus — the visitor is never left guessing which field;
     · .is-bad clears the moment the visitor types in that field again;
     · an untouched dropdown reads as a placeholder (.is-placeholder), not as
       an answer.

   The reference then swaps the form for a "done" panel in the browser. Here
   it does not: the card posts to Shopify, and sections/x-ct-ask.liquid
   renders the SAME panel server-side from form.posted_successfully?, so the
   success state survives the redirect Shopify performs.

   EVERYTHING IS DELEGATED FROM document — no per-instance wiring, so a
   section dropped in by the theme editor (shopify:section:load) works with
   no re-init, and two enquiry forms on one page cannot collide.

   Email is validated here as well as by Shopify: contact[email] is the ONE
   field the platform requires, and letting it round-trip to the server just
   to bounce back with an error page is a worse answer than saying so here.
   ============================================================ */

(function () {
  'use strict';

  var FORM = '.x-ask__form';
  var FIELD = '.x-fld';

  function mark(input, bad) {
    var field = input.closest(FIELD);
    if (!field) return;
    field.classList.toggle('is-bad', bad);
    input.setAttribute('aria-invalid', bad ? 'true' : 'false');
  }

  /* empty is invalid; a filled email must also look like one. `novalidate`
     only silences the browser's UI — validity is still computed. */
  function isBad(input) {
    if (input.disabled) return false;
    if (!input.required) return false;
    if (!input.value.trim()) return true;
    return input.validity ? input.validity.typeMismatch : false;
  }

  function placeholderState(select) {
    select.classList.toggle('is-placeholder', !select.value);
  }

  function paintSelects(root) {
    (root || document).querySelectorAll(FORM + ' .x-fld__sel select').forEach(placeholderState);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest(FORM) : null;
    if (!form) return;

    var first = null;

    form.querySelectorAll('input[required], textarea[required], select[required]').forEach(function (input) {
      var bad = isBad(input);
      mark(input, bad);
      if (bad && !first) first = input;
    });

    if (first) {
      event.preventDefault();
      first.focus();
      if (typeof first.scrollIntoView === 'function') {
        first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  });

  /* the moment the visitor answers the complaint, drop it */
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.closest || !input.closest(FORM)) return;
    var field = input.closest(FIELD);
    if (field && field.classList.contains('is-bad') && !isBad(input)) mark(input, false);
  });

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.closest || !select.closest(FORM)) return;
    if (select.tagName === 'SELECT') placeholderState(select);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      paintSelects();
    });
  } else {
    paintSelects();
  }

  document.addEventListener('shopify:section:load', function (event) {
    paintSelects(event.target);
  });
})();
